export default __webpack_public_path__ + "cd4986044b46d0a890e7e0922fb61ef3.png";